import React, {Component} from 'react'
import './CanDataReport.css'
import InTable from '../InTable/InTable'

class CanDataReport extends Component{
    componentDidUpdate() {
        // if (window.canData) {
        //     if (window.renderCanTable){
        //     // this.refs.table.setData(window.canData);
        //     }
        // }
        // window.renderCanTable = false


        if (this.props.schemaKey === "can_data_report" && window.canData && window.renderCanDataReport) {
            this.refs.table.setData(window.canData);
            window.renderCanDataReport = false;
        }
        if (this.props.schemaKey === "jem_can_data_report" && window.jemCanData && window.renderJemCanDataReport) {
            this.refs.table.setData(window.jemCanData);
            window.renderJemCanDataReport = false;
        }
        if (this.props.schemaKey === "bg_can_data_report" && window.bgCanData && window.renderBgCanDataReport) {
            this.refs.table.setData(window.bgCanData);
            window.renderBgCanDataReport = false;
        }
    }
    render(){
        let canTableMeta = {
            head: [
                {key: "slno", name: "Sl No"},
                { key: "vehicleno", name: "", name: "Vehicle No" },
                { key: 'time', name: 'Date' },
                { key: 'parameter', name: 'Parameter' },
                { key: 'value', name: 'Value' },
            ],
            _position: {
                width: 1000,
            }
        }
        return(
            <InTable ref="table" data={canTableMeta} schemaKey={this.props.schemaKey} /> //schemaKey ="can_data_report"
        )
    }
}

export default CanDataReport